import { service } from '@/ajax/request'
export const getUserDetectionRecordList = (params) => {
    return service({
        url: `/fdm-user-record/queryUserDetectionRecord`,
        method: 'POST',
        params
    })
}

export const getMixDetectionRecordList = (params) => {
    return service({
        url: `/mix-detection-user-record/query`,
        method: 'POST',
        params
    })
}